import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePWAInstall } from '@/hooks/usePWAInstall';
import { t } from '@/lib/i18n';

export function PWAInstallBanner() {
  const { canInstall, install, dismiss } = usePWAInstall();

  if (!canInstall) return null;

  return (
    <div className="fixed bottom-[max(1rem,env(safe-area-inset-bottom))] left-4 z-50 max-w-sm bg-white rounded-xl shadow-lg border border-slate-200 p-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
          <Download className="w-5 h-5 text-blue-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-900">
            Installer {t('brand.name')}
          </p>
          <p className="text-xs text-slate-500 mt-1">
            Accédez rapidement à l'application depuis votre écran d'accueil.
          </p>
          <div className="flex gap-2 mt-3">
            <Button
              size="sm"
              onClick={install}
              className="bg-blue-600 hover:bg-blue-700 text-xs"
            >
              Installer
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={dismiss}
              className="text-xs text-slate-500"
            >
              Plus tard
            </Button>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="flex-shrink-0 text-slate-400 hover:text-slate-600"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
